var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.376 17.436-7.12-7.12A.85.85 0 0 1 4 9.694a.85.85 0 0 1 .257-.624l.807-.808a.85.85 0 0 1 .624-.256.74.74 0 0 1 .624.22L12 13.913l5.688-5.688a.74.74 0 0 1 .624-.22.85.85 0 0 1 .624.256l.807.808a.85.85 0 0 1 .257.624.85.85 0 0 1-.257.624l-7.12 7.119a.8.8 0 0 1-.623.293.8.8 0 0 1-.624-.293"
  })));
};
export default SvgChevronDown;